<template lang="html">
   <footer class="footer">
     <p class="flex items-center justify-center h-10">
         ©  2019  Karin Hamano
       </p>
   </footer>
 </template>
 
 <script>
 export default {
 }
 </script>
 
 <style lang="css" scoped>
 .footer{
    position: absolute;
    width: 100vw;
    bottom: 0;
    padding: 10px;
    line-height: 10px;
    background-color: #432444;
    color: #fff;
    font-size: 15px;
 }
p {
    text-align: center;
  }
  </style>